import { CreateCategoryRequest } from '@bluestone-node-sdk/pim';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';

const showRegionNameErrorModal = () => {
    const errorMessageContent = (
        <div className="items-center flex flex-col">
            <div>Følgende felfer er feil</div>
            <div>Navn</div>
            <div>Klikk på teksten for å fjerne denne meldingen.</div>
        </div>
    );
    showMessageModal('error', errorMessageContent);
};

const createRegion = async () => {
    const { regionStore, adminStore } = getStore();

    const payload: CreateCategoryRequest = {
        name: regionStore.regionName.trim(),
        parentId: adminStore.election?.id || '',
    };

    await regionStore.createRegion(payload);
    regionStore.setRegionName('');
};

export const submitCreateRegion = () => {
    const { regionStore } = getStore();
    const isValid = !!regionStore.regionName.trim();

    regionStore.setRegionNameError(!isValid);

    if (isValid) {
        return createRegion();
    }

    return showRegionNameErrorModal();
};
